import { teacherServiceURL } from '../endpoint';

export function imageUrl() {
  const url = new URL(teacherServiceURL);
  url.pathname += 'images';
  return url;
}

export function imageUploadUrl() {
  const url = imageUrl();
  url.pathname += '/upload';
  return url;
}
